export default __webpack_public_path__ + "static/media/move-folder.24bed035.svg";